import React, { Component } from 'react'
import './zipupload.css'
import { Progress } from 'semantic-ui-react'
import { Button, Modal, Select, Input, Icon } from 'antd';
import UploadCloud from 'react-icons/lib/md/cloud-upload'
import axios from 'axios'
import Dropzone from 'react-dropzone'
import JSZip from 'jszip'
import Ziptable from './newtmptable.js'

const Option = Select.Option;
const { TextArea } = Input;

const searchArrObj = (nameKey, myArray) => {
    for (let i=0; i < myArray.length; i++) {
        if (myArray[i].value === nameKey) {
            return myArray[i].text;
        }
    }
}

class zipupload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productTypeOptions: [],
      productTypeValue: '',
      fullProductTypes: [],
      templateThemeOptions: [],
      templateThemeValue: 0,
      eventOptions: [],
      eventValue: 0,
      designerOptions: [],
      designerValue: 2,
      fitTypeInput: 'Men,Women,Youth',
      colorsValue: '',
      listPriceValue: '',
      featureOneValue: '',
      featureTwoValue: '',
      descriptionValue: '',
      dateAddedValue: '',
      uploadIndValue: 0,
      isDataModalOpen: false,
      isProgressModalOpen: false,
      zipFileName: '',
      zipFileSize: '',
      contentsOfZip: [],
      resultsMerchUploadQueue: [],
      resultsMerchZipFiles: [],
      insertedZipRow: 0,
      updateProgressBar: 0,
      totalProgressBar: 0,
      fileUploading: 0,
      allZipFinishedInd: 0,
      multiZipUpload: false,
      extraZipCount: 0
    }

    this.changeDescription = this.changeDescription.bind(this)
    this.showModalOrNot = this.showModalOrNot.bind(this)
    this.UploadFile = this.UploadFile.bind(this)
    this.getAllZipData = this.getAllZipData.bind(this)
    this.RemoveZipData = this.RemoveZipData.bind(this)
    this.preUploadFile = this.preUploadFile.bind(this)
  }

  async componentWillMount() {
    var self = this;
    var today = new Date();
    var currentDate = ((today.getMonth()+1) + '/' + today.getDate() + '/' + today.getFullYear());
    var productTypeOptionsArr = [];
    var templateThemeOptionsArr = [];
    var eventOptionsArr = [];
    var designerOptionsArr = [];
    var tmpObj = {};
    var standardDesc = '';

    //This get request gives us all the shirt type
    axios.get('/api/shirtType').then(function(results) {
      self.setState({fullProductTypes: results.data})
      results.data.forEach(function(shirt, i) {
        if (shirt.producttype === "Standard T-Shirt") {
          self.setState({productTypeValue: shirt.id, listPriceValue: shirt.listprice})
        }
        tmpObj.text = shirt.producttype;
        tmpObj.value = shirt.id;
        productTypeOptionsArr.push(tmpObj)
        tmpObj = {}
      })
    })

    axios.get('/api/templateTheme').then(function(results) {
      tmpObj.text = "None";
      tmpObj.value = 0;
      templateThemeOptionsArr.push(tmpObj)
      tmpObj = {}
      results.data.forEach(function(theme, i) {
        tmpObj.text = theme.templatetheme;
        tmpObj.value = theme.id;
        templateThemeOptionsArr.push(tmpObj)
        tmpObj = {}
      })
    })

    axios.get('/api/events').then(function(results) {
      tmpObj.text = "None";
      tmpObj.value = 0;
      eventOptionsArr.push(tmpObj)
      tmpObj = {}
      results.data.forEach(function(event, i) {
        tmpObj.text = event.name;
        tmpObj.value = event.id;
        eventOptionsArr.push(tmpObj)
        tmpObj = {}
      })
    })

    axios.get('/api/designer').then(function(results) {
      results.data.forEach(function(designer, i) {
        tmpObj.text = designer.designer;
        tmpObj.value = designer.id;
        designerOptionsArr.push(tmpObj)
        tmpObj = {}
      })
    })

    await axios.get('/api/standardMerchDescription').then(function(results) {
      standardDesc = results.data[0].merchdescription
    })

    this.setState({dateAddedValue: currentDate, productTypeOptions: productTypeOptionsArr, templateThemeOptions: templateThemeOptionsArr
      ,eventOptions: eventOptionsArr, designerOptions: designerOptionsArr, descriptionValue: standardDesc})
  }

  showModalOrNot() {
    if (this.state.isDataModalOpen === false) {
      this.setState({isDataModalOpen: true})
    } else {this.setState({isDataModalOpen: false})}

    //console.log(this.state.isDataModalOpen)
  }

  switchAllZipFinishedInd = () => {
    let newInd = this.state.allZipFinishedInd === 0 ? 1 : 0;
    this.setState({allZipFinishedInd: newInd})
    this.getAllZipData(newInd)
  }

  showZipLoaderOrNot() {
    if (this.state.isProgressModalOpen === false) {
      this.setState({isProgressModalOpen: true})
    } else {this.setState({isProgressModalOpen: false})}
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    var zip = new JSZip();
    var zipArr = []
    var errors = 0
    // do stuff with files...
    this.setState({zipFileName: acceptedFiles[0].name, zipFileSize: ((acceptedFiles[0].size/1000)/1000).toFixed(2) + "MB", fileUploading: 1})
    if (acceptedFiles[0].name.substring(acceptedFiles[0].name.length - 3) !== 'zip') {
      alert('File must be a zip');
      errors = 1
    }

    if (errors === 0) {
      let data = new FormData();
      data.append('foo', 'bar');
      data.append('file', acceptedFiles[0]);
      let numberOfZips = 0

      zip.loadAsync(acceptedFiles[0])
      .then((zip) => {
        console.log(zip.files);
        for (let key in zip.files) {
          console.log(key)
          if (key.substring(key.length - 3) === 'zip') {
            this.setState({multiZipUpload: true})
            numberOfZips++
          }
          zipArr.push(key)
        }

        this.setState({contentsOfZip: zipArr, extraZipCount: numberOfZips})
      });

      axios.post('/files', data)
        .then((res) => {
          console.log(res)
          this.setState({fileUploading: 100})
        })
        .catch((err) => {
          console.log(err)
        });

        this.showModalOrNot()
      };



  }

  preUploadFile() {
    //console.log(this.state.contentsOfZip.length)
    this.setState({totalProgressBar: this.state.contentsOfZip.length})

    this.UploadFile()
  }

  async UploadFile() {
    var errors = 0
    if (this.state.dateAddedValue.length > 10 || this.state.dateAddedValue.length < 8) {
      alert("Date must be correct character length")
      errors = 1
    }

    const ArrayMax = this.state.productTypeValue.length === undefined ? 1 : this.state.productTypeValue.length
    //loop through productTypeValue's

    let zipExists = true

    await axios.get('/checkFileUploaded', {
      params: {
        zipName: this.state.zipFileName
      }
    })
    .then((results) => {
      console.log(results)
      if (results.data === false) {
        zipExists = false
      }
    })

    if (zipExists) {
      for (let p = 0; p < ArrayMax; p++) {
        let currentProductType = this.state.productTypeValue.length > 1 ? this.state.productTypeValue[p] : this.state.productTypeValue
        let newZipName = this.state.productTypeValue.length > 1
          ? this.state.zipFileName + " - " + searchArrObj(currentProductType, this.state.productTypeOptions) + ".zip" : this.state.zipFileName;

        if (this.state.productTypeValue.length > 1) {
          await axios.post('/copyFile', {
            originalZip: this.state.zipFileName,
            destinationZip: newZipName,
            deleteOriginal: (p + 1) === ArrayMax ? true : false
          })
          .then((results) => {
            console.log(results)
          })
        }

        if (errors === 0) {
          let myListPrice = this.state.listPriceValue
          this.state.fullProductTypes.forEach((shirt, i) => {
            if (shirt.id === currentProductType) myListPrice = shirt.listprice
          })
          var splitDateString = this.state.dateAddedValue.split('/')
          var newRealDate = new Date(splitDateString[2],splitDateString[0]-1,splitDateString[1]).toISOString()
          var buildFirstInsertObject = {zipfile: newZipName, shirttype_id: currentProductType, fittype: this.state.fitTypeInput, colors: this.state.colorsValue
            ,listprice: myListPrice, feature1: this.state.featureOneValue, feature2: this.state.featureTwoValue, description: this.state.descriptionValue
            ,dateadded: newRealDate, upload_ind: this.state.uploadIndValue, merchtemplatetheme_id: this.state.templateThemeValue
            ,merchcalendar_id: this.state.eventValue, merchdesigner_id: this.state.designerValue, zipfileind: 1}
          var insertedZipRow = 0

          await axios.post('/api/insertZipFile', {
              buildInsertObject: buildFirstInsertObject
          })

          .then(function(results) {
            if (results.data === "failed") {
              alert("Zip file failed to insert into the database...\nTry again later...")
            }
            //console.log(results);
            insertedZipRow = results.data.insertId
          })

          for (var i = 0; i< this.state.contentsOfZip.length; i++) {
            var newTitle = this.state.contentsOfZip[i].substring(0, this.state.contentsOfZip[i].length - 4)
            //console.log(this.state.contentsOfZip[i].substring(5))

            if (
              this.state.contentsOfZip[i].substring(this.state.contentsOfZip[i].length - 3) === "png" &&
              this.state.contentsOfZip[i].substring(0, 5) !== "__MAC"
              ) {

              let myListPrice = this.state.listPriceValue
              this.state.fullProductTypes.forEach((shirt, i) => {
                if (shirt.id === currentProductType) myListPrice = shirt.listprice
              })

              var buildMultiInsertObject = {merchzipfiles_id: insertedZipRow, title: newTitle, shirttype_id: currentProductType, fittype: this.state.fitTypeInput
                ,colors: this.state.colorsValue, listprice: myListPrice, feature1: this.state.featureOneValue, feature2: this.state.featureTwoValue
                ,merchtemplatetheme_id: this.state.templateThemeValue, merchcalendar_id: this.state.eventValue, merchdesigner_id: this.state.designerValue, finished_ind: 0
                ,description: this.state.descriptionValue, imagefilename: this.state.contentsOfZip[i]}

              await axios.post('/api/insertIndividualZipContents', {
                  buildInsertObject: buildMultiInsertObject
              })

              .then(function(results) { //eslint-disable-line
                if (results.data === "failed") {
                  alert("Zip file failed to insert into the database...\nTry again later...\n" & buildMultiInsertObject.title)
                }
              })

            }
            this.setState({updateProgressBar: i})
          }

          this.setState({insertedZipRow: insertedZipRow})
        }
      }
      this.showModalOrNot()

      this.getAllZipData()
    } else {
      alert('Please wait for file to be completely uploaded before continueing.')
    }
  }

  getAllZipData(newInd) {
    var self = this;
    const finishedInd = newInd !== undefined ? newInd : this.state.allZipFinishedInd;
    axios.get('/api/getAllMerchZipFiles', {
      params: {
        finishedInd: finishedInd
      }
    }).then(function(results) {
      self.setState({resultsMerchZipFiles: results.data})
    })
  }

  RemoveZipData() {
    this.setState({resultsMerchUploadQueue: []})
    this.setState({resultsMerchZipFiles: []})
  }

  changeProduct = (e) => {
    const switchValue = e
    for (var i = 0; i < this.state.fullProductTypes.length; i++) {
      if(this.state.fullProductTypes[i].id === switchValue) {
        var listPriceValue = this.state.fullProductTypes[i].listprice
        this.setState({listPriceValue})
      }
    }
    this.setState({productTypeValue: switchValue})
  }

  changeDescription = (id, value, e) => {
    // console.log(id, value.target.value)
    var switchID
    var switchValue
    var errors = 0

    if(id !== "") {

      switchID = id
      switchValue = value.target !== undefined ? value.target.value : value;
      if (switchID === 'uploadIndField') {
        if (switchValue !== '0' && switchValue !== '1') {
          alert("Upload Indicator can only by 1 or 0!");
          errors = 1
        }
      }

      if (errors === 0) {
        let index = switchID.indexOf("Field");
        let id = (switchID.substring(0, index) + "Value");
        this.setState({[id]: switchValue});
      }
    }

  }

  render() {
    const {multiZipUpload} = this.state;
    let dropperOrTable
    if (this.state.totalProgressBar > 0) {
      var progressBar = <Progress value={this.state.updateProgressBar} total={this.state.totalProgressBar} progress='ratio' color='blue' style={{marginTop: '5px', marginBottom: '10px'}} active>
            Uploading zip data...
          </Progress>
    } else {var progressBar} //eslint-disable-line

    const modalHeader = <div>
      Zip Upload Information -
      <span style={{fontWeight: '100', fontStyle: 'italic', fontSize: '18px'}}> {this.state.zipFileName} / {this.state.zipFileSize}
        <Progress percent={this.state.fileUploading} active autoSuccess style={{float: 'right', width: '45%', left: '-10px'}}>Uploading Zip File...</Progress>
      </span>
    </div>;

    if (this.state.resultsMerchZipFiles.length > 0) {
      dropperOrTable = <Ziptable merchZipFiles={this.state.resultsMerchZipFiles} merchUploadQueue={this.state.resultsMerchUploadQueue}
        goBack={this.RemoveZipData} insertedZipRow={this.state.insertedZipRow} productTypeOptions={this.state.productTypeOptions} templateThemeOptions={this.state.templateThemeOptions}
        eventOptions={this.state.eventOptions} designerOptions={this.state.designerOptions} fullProductTypes={this.state.fullProductTypes} fileUploading={this.state.fileUploading}
        switchAllZipFinishedInd={this.switchAllZipFinishedInd} getAllZipData={this.getAllZipData}/>;
    } else {
      dropperOrTable = <div>
      <h1>Upload zip file by clicking button below</h1>
        <Dropzone onDrop={this.onDrop.bind(this)} style={{width: '500px', height: '400px', borderStyle: 'dashed', textAlign: 'center', borderColor: '#6d6d6d'}}>
          <p>Drag and drop zip file here or click the button to browse for the file.</p>
          <Button type="primary" onClick={this.state.showModalOrNot}>Upload <UploadCloud/></Button>

        </Dropzone>
        <br/>
        <Button onClick={this.getAllZipData}>Click here to skip upload</Button>
      </div>;


    }

    const myModal = <Modal
              title={modalHeader}
              visible={this.state.isDataModalOpen}
              onOk={this.preUploadFile}
              onCancel={this.showModalOrNot}
              width={'80%'}
              footer={[
                <Button key="back" onClick={this.showModalOrNot} style={{marginRight: 8}}>
                Close
                </Button>,
                <Button key="submit" type="primary" onClick={this.preUploadFile}>
                  Upload Zip<Icon type='right' />
                </Button>
              ]}
            >
                <div className="zipModalDescription">Shirt Type:
                  <Select id="productTypeField" defaultValue={1} style={{ width: 400, marginLeft: 6 }} onChange={this.changeProduct} mode="multiple">
                    {this.state.productTypeOptions.map(product => (
                      <Option key={product.value} value={product.value}>{product.text}</Option>
                    ))}
                  </Select>
                </div>

                <div className="zipModalDescription">Fit Type:
                  <Input
                    id="fitTypeField"
                    value={this.state.fitTypeInput}
                    onChange={this.changeDescription.bind(this, "fitTypeField")}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">Colors:
                  <Input
                    id="colorsField"
                    placeholder="green,blue"
                    value={this.state.colorsValue}
                    onChange={this.changeDescription.bind(this, "colorsField")}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">List Price:
                  <Input
                    id="listPriceField"
                    labelPosition='left'
                    type='text'
                    value={this.state.listPriceValue}
                    onChange={this.changeDescription.bind(this, "listPriceField")}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">Feature 1:
                  <Input
                    id="featureOneField"
                    placeholder="feature..."
                    value={this.state.featureOneValue}
                    onChange={this.changeDescription.bind(this, "featureOneField")}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">Feature 2:
                  <Input
                    id="featureTwoField"
                    placeholder="feature..."
                    value={this.state.featureTwoValue}
                    onChange={this.changeDescription.bind(this, "featureTwoField")}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">Description:
                  <TextArea
                    id="descriptionField"
                    autosize
                    style={{'width': '89%', 'verticalAlign': 'top', 'marginLeft': '5px'}}
                    value={this.state.descriptionValue}
                    onChange={this.changeDescription.bind(this, "descriptionField")}
                  />
                </div>

                <div className="zipModalDescription">Template Theme:
                  <Select
                    id="templateThemeField"
                    showSearch
                    style={{ width: 400, marginLeft: 6 }}
                    placeholder='Template Theme...'
                    optionFilterProp="children"
                    value={this.state.templateThemeValue}
                    onChange={this.changeDescription.bind(this, 'templateThemeField')}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {this.state.templateThemeOptions.map(template => (
                      <Option key={template.value} value={template.value}>{template.text}</Option>
                    ))}
                  </Select>
                </div>

                <div className="zipModalDescription">Event:
                  <Select
                    id="eventField"
                    showSearch
                    style={{ width: 400, marginLeft: 6 }}
                    placeholder='Event...'
                    optionFilterProp="children"
                    value={this.state.eventValue}
                    onChange={this.changeDescription.bind(this, 'eventField')}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {this.state.eventOptions.map(event => (
                      <Option key={event.value} value={event.value}>{event.text}</Option>
                    ))}
                  </Select>
                </div>

                <div className="zipModalDescription">Designer:
                  <Select
                    id="designerField"
                    style={{ width: 400, marginLeft: 6 }}
                    placeholder='Designer...'
                    value={this.state.designerValue}
                    onChange={this.changeDescription.bind(this, 'designerField')}
                  >
                    {this.state.designerOptions.map(designer => (
                      <Option key={designer.value} value={designer.value}>{designer.text}</Option>
                    ))}
                  </Select>
                </div>

                <div className="zipModalDescription">Date Added (mm/dd/yyyy):
                  <Input
                    id="dateAddedField"
                    value={this.state.dateAddedValue}
                    onChange={this.changeDescription.bind(this)}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>

                <div className="zipModalDescription">Upload Ind:
                  <Input
                    id="uploadIndField"
                    value={this.state.uploadIndValue}
                    type="number"
                    onChange={this.changeDescription.bind(this)}
                    style={{width: 400, marginLeft: 6}}
                  />
                </div>
              {progressBar}

          </Modal>;

    return (
      <div className="zipupload">

        {dropperOrTable}
        {myModal}

      </div>
    );
  }
}

export default zipupload;



// WEBPACK FOOTER //
// ./src/pages/zipupload.js